module.exports = __webpack_public_path__ + "static/media/entry-background.6a318067.png";